import { createSlice } from "@reduxjs/toolkit";

export const workoutSetup = createSlice({
    name: "workoutSetupData",
    initialState: {
        exerciseNameLocal: "",
        exerciseName: "",
        difficulty: "",
        character: "",
        music: "",
    },
    reducers: {
        createWorkoutSetupData: (state, { payload }) => {
            const {
                exerciseNameLocal,
                exerciseName,
                difficulty,
                difficultyLocal,
                character,
                music,
            } = payload;

            state.exerciseNameLocal = exerciseNameLocal;
            state.exerciseName = exerciseName;
            state.difficulty = difficulty;
            state.difficultyLocal = difficultyLocal;
            state.character = character;
            state.music = music;

            localStorage.setItem("workoutSetupData", JSON.stringify(state));
        },
    },
});

export const { createWorkoutSetupData } = workoutSetup.actions;
export default workoutSetup.reducer;
